import React from 'react';
import { journeys } from './homeContent';
import { ContactLink, ServiceIcon } from './HomeUI';

export default function SectionFour({ selected, onSelect, headingRef }) {
  const journey = journeys.find(item => item.id === selected) || journeys[0];
  return <section id="home-process" className="home-section home-process">
    <div className="home-container">
      <div className="home-section-heading">
        <p className="home-eyebrow">How we work</p>
        <h2 ref={headingRef} tabIndex={-1}>A clear path from<br /><span>opportunity to operation.</span></h2>
        <p>Explore a service to see how we investigate, deliver, and support it. Every engagement starts with your business goals and a scope agreed together.</p>
      </div>
      <div className="home-journey-options" aria-label="Explore a service process">
        {journeys.map(item => <button key={item.id} id={`journey-${item.id}`} aria-pressed={journey.id === item.id} aria-controls="home-journey-detail" onClick={() => onSelect(item.id)}>
          <ServiceIcon name={item.id === 'operations' ? 'operations' : item.id} />
          <span>{item.title}<small>{item.short}</small></span>
        </button>)}
      </div>
      <div id="home-journey-detail" className="home-journey-detail" role="region" aria-labelledby={`journey-${journey.id}`}>
        <div className="home-journey-intro"><span className="home-eyebrow">The process</span><h3>{journey.title}</h3><p>{journey.intro}</p></div>
        <ol className="home-steps">
          {journey.steps.map(([title, description], index) => <li key={title}><span className="home-step-number" aria-hidden="true">{String(index + 1).padStart(2, '0')}</span><div><h4>{title}</h4><p>{description}</p></div></li>)}
        </ol>
        <div className="home-outcome"><strong>What you take forward</strong><p>{journey.outcome}</p></div>
      </div>
      <div className="home-final-cta"><div><p className="home-eyebrow">Let’s find your next step</p><h2>What could work better<br />in your business?</h2><p>Tell us about your goals. We’ll help you identify where software, AI, or automation can make a difference.</p></div><ContactLink>Talk with Blake Technologies</ContactLink></div>
    </div>
  </section>;
}
